import script from "./color-phase.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-phase.vue?vue&type=script&setup=true&lang=ts"

import "./color-phase.vue?vue&type=style&index=0&id=2b80260b&lang=scss"

const __exports__ = script;

export default __exports__